export default __webpack_public_path__ + "static/media/LamoxPTransparent.add30273.png";